const Tooltip = ({ text, children }) => {
  return (
    <div className="tooltip">
      {children}
      <span className="tooltiptext font-roboto-flex">{text}</span>
    </div>
  );
};

export default Tooltip;
